// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".schutzundrettung-h3{min-width:130px}", "",{"version":3,"sources":["webpack://./src/views/SchutzUndRettung.vue"],"names":[],"mappings":"AACA,qBACE,eAAA","sourcesContent":["\n.schutzundrettung-h3 {\n  min-width: 130px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
